import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import styles from './FileDetailModal.module.scss';
import adminService from '../../../services/adminService';

// const BACKEND_URL = 'http://localhost/tramhuong';
const BACKEND_URL = 'https://huongtramcomoc.vn';

const FileDetailModal = ({ isOpen, onClose, file, onSaveSuccess }) => {
  const [nameInput, setNameInput] = useState('');
  const [altInput, setAltInput] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (file) {
      setNameInput(file.file_name);
      setAltInput(file.alt_text || '');
    }
  }, [file]);

  if (!file) {
    return null;
  }

  const handleSave = () => {
    setLoading(true);
    adminService.updateMediaFile(file.id, nameInput, altInput)
      .then(() => {
        setLoading(false);
        onSaveSuccess();
        onClose(); 
      })
      .catch(err => {
        setLoading(false);
        alert("Lỗi khi cập nhật: " + err.response.data.message);
      });
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
      style={{ overlay: { zIndex: 1050 }, content: { zIndex: 1051 } }}
    >
      <div className={styles.header}>
        <h3>Chi tiết file</h3>
      </div>

      <div className={styles.content}>
        <img src={`${BACKEND_URL}${file.file_path}`} alt="Preview" className={styles.previewImage} />
        
        <div className={styles.formGroup}>
          <label>Tên file</label>
          <input 
            type="text" 
            value={nameInput}
            onChange={(e) => setNameInput(e.target.value)}
          />
        </div>
        
        <div className={styles.formGroup}>
          <label>Văn bản thay thế (Alt Text)</label>
          <input 
            type="text" 
            value={altInput}
            onChange={(e) => setAltInput(e.target.value)}
          />
        </div>
      </div>
      
      <div className={styles.footer}>
        <button onClick={onClose} className={styles.cancelButton}>
          Đóng
        </button>
        <button onClick={handleSave} className={styles.saveButton} disabled={loading}>
          {loading ? 'Đang lưu...' : 'Lưu'}
        </button>
      </div>
    </ReactModal>
  );
};

export default FileDetailModal;